import  { memo } from "react";
import { Empty } from 'antd-mobile'

import logo from "../../images/index/logo.png";
import styles from  './index.module.scss'
interface emptyProps {
  description: string
}
const Index = (props: emptyProps) => {
  const  {description }  = props
  const ImageElemnt = () => {
    return <img src={logo}  className={styles.logo}  alt="" />
  }
  return <div>
    <Empty
          style={{ padding: '64px 0' ,color:'#EB6C00'}}
          image={
            <ImageElemnt />
          }
          description={description}
        />
  </div>
}
export default memo(Index);